import { ReactNode } from "react";
import { Label4 } from "../../typography/components/Label";

export const Title = ({ children }: { children: ReactNode }) => (
  <Label4 className="mb-5">{children}</Label4>
);
